import { DispatchListDetailsRes } from '@zonofi/zono-money-store';
import { ReactComponent as DocketNumber } from '@zonofi/svg-icons/docket-number.svg';
import { ReactComponent as UserIcon } from '@zonofi/svg-icons/user-icon.svg';
import { ReactComponent as BoxIcon } from '@zonofi/svg-icons/box-icon.svg';
import { ReactComponent as WeightIcon } from '@zonofi/svg-icons/weight-icon.svg';
import { ReactComponent as CalendarIcon } from '@zonofi/svg-icons/calendar-icon.svg';

interface DispatchDetailsProps {
  dispatchNoteDetails: DispatchListDetailsRes;
}

const getValue = (value: string | number | null | undefined) => value || 'N/A';
export const DispatchDetails = (props: DispatchDetailsProps) => {
  const { dispatchNoteDetails } = props;

  return (
    <div className="dispatch-note-detail-box font-regular">
      <span className="dispatch-note-detail-box-heading font-semibold">
        Dispatch Details
      </span>
      <div className="dispatch-note-detail-box-content">
        <DocketNumber />
        <div className="dispatch-note-detail-box-content-text">
          <span className="dispatch-note-detail-box-content-text-label">
            AWB/LR/Docket Number:{' '}
          </span>
          <span className="dispatch-note-detail-box-content-text-value">
            {getValue(dispatchNoteDetails?.dispatchDocNumber)}
          </span>
        </div>
      </div>
      <div className="dispatch-note-detail-box-content">
        <UserIcon />
        <div className="dispatch-note-detail-box-content-text">
          <span className="dispatch-note-detail-box-content-text-label">
            Customer Name:{' '}
          </span>
          <span className="dispatch-note-detail-box-content-text-value">
            N/A
          </span>
        </div>
      </div>
      <div className="dispatch-note-detail-box-content">
        <BoxIcon />
        <div className="dispatch-note-detail-box-content-text">
          <span className="dispatch-note-detail-box-content-text-label">
            Box:{' '}
          </span>
          <span className="dispatch-note-detail-box-content-text-value">
            {getValue(dispatchNoteDetails?.numOfBoxes)}
          </span>
        </div>
      </div>
      <div className="dispatch-note-detail-box-content">
        <WeightIcon />
        <div className="dispatch-note-detail-box-content-text">
          <span className="dispatch-note-detail-box-content-text-label">
            Total Weight:{' '}
          </span>
          <span className="dispatch-note-detail-box-content-text-value">
            {getValue(dispatchNoteDetails?.totalWeightINKg)}
          </span>
        </div>
      </div>
      <div className="dispatch-note-detail-box-content">
        <CalendarIcon color="#ffffff" />
        <div className="dispatch-note-detail-box-content-text">
          <span className="dispatch-note-detail-box-content-text-label">
            Dispatch Date:{' '}
          </span>
          <span className="dispatch-note-detail-box-content-text-value">
            {getValue(dispatchNoteDetails?.dispatchDate)}
          </span>
        </div>
      </div>
      <div className="dispatch-note-detail-box-content">
        <CalendarIcon color="#ffffff" />
        <div className="dispatch-note-detail-box-content-text">
          <span className="dispatch-note-detail-box-content-text-label">
            Delivery Date:{' '}
          </span>
          <span className="dispatch-note-detail-box-content-text-value">
            {getValue(dispatchNoteDetails?.deliveryDate)}
          </span>
        </div>
      </div>
    </div>
  );
};
